// extracted by mini-css-extract-plugin
export var checkbox = "_32-0";
export var circle = "_32-3";
export var horizontalContainer = "_32-7";
export var sm = "_32-5";
export var switch0 = "_32-2";
export var switchDisabled = "_32-8";
export var switchEnabled = "_32-1";
export var textSwitchContainer = "_32-9";
export var textSwitchOption = "_32-a";
export var textSwitchOptionSelected = "_32-b";
export var verticalContainer = "_32-6";
export var xs = "_32-4";